export default __webpack_public_path__ + "static/media/intro4.1d15fc81.mp3";